"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const react_2 = require("@xstate/react");
const xstate_1 = require("xstate");
const ApptDetails_1 = __importDefault(require("./ApptDetails"));
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
const propTypes = {
    awsMapConfig: prop_types_1.object,
    config: prop_types_1.object.isRequired,
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    track: prop_types_1.func.isRequired
};
function ApptSummary({ awsMapConfig, config, service, track }) {
    const [state] = (0, react_2.useService)(service);
    const { provider, bookedAppt, location, selectedAppointment, appointmentQuery, visibility, featureFlags, waitlistStatus } = state.context;
    const apptLocation = (0, utils_1.getApptLocation)(provider, selectedAppointment);
    return (react_1.default.createElement(styles_1.ApptSummaryContainer, { "data-testid": "ApptSummary" },
        react_1.default.createElement(ApptDetails_1.default, { provider: provider, appointment: bookedAppt, location: location, track: track, config: config, featureFlags: featureFlags, awsMapConfig: awsMapConfig, selectedAppointment: selectedAppointment, apptLocation: apptLocation, appointmentQuery: appointmentQuery, visibility: visibility, waitlistStatus: waitlistStatus })));
}
exports.default = ApptSummary;
ApptSummary.propTypes = propTypes;
//# sourceMappingURL=ApptSummary.js.map